'use client'

import React, { FC } from 'react'
import Link from '@/components/link'
import classNames from 'classnames'
import ButtonOutlinedGradientEpic from '@/components/button-outlined-gradient-epic'

import styles from './CollectionRow.module.css'
import RuneCardSmall from '@/components/rune-card-small'
import { CollectionsFeedFilters } from '@/utils/types/feed'
import { formatRune } from '@/utils/format-rune'

const _DEFAULT_KEY = 'volume_week'

const CollectionRow: FC<{
	selectedKey: CollectionsFeedFilters
	collection: any
	className?: string
	selectedTitle?: string
}> = (props) => {
	const { className, collection } = props

	return (
		<Link className={styles.link} href={`/collection/${props?.collection?.slug}`}>
			<div className={classNames({ [(props?.className as any)]: !!className }, styles.row)}>
				<div className={classNames(styles.inscription, styles.column)}>
					<RuneCardSmall rank={-1} className={styles.card} collection={props?.collection} />
				</div>
				<div className={classNames(styles.column, styles.priceColumn, styles.hideMobile, styles.hideTablet)}>
					<div className={styles.listed}>{formatRune(collection.supply, collection)}</div>
				</div>
				<div className={classNames(styles.column, styles.priceColumn, styles.hideMobile)}>
					<div className={styles.listed}>{props?.collection?.owners || 0}</div>
				</div>
				<div className={classNames(styles.column)}>
					{props?.collection?.mintable ? (
						<ButtonOutlinedGradientEpic
							size="small"
							className="whitespace-nowrap rounded-full text text-sm h-8 mr-2"
						>
							Mint
						</ButtonOutlinedGradientEpic>
					) : (
						<ButtonOutlinedGradientEpic
							size="small"
							className="whitespace-nowrap rounded-full text text-sm h-8 mr-2"
						>
							View
						</ButtonOutlinedGradientEpic>
					)}
				</div>
			</div>
		</Link>
	)
}

export default CollectionRow
